import React from "react";
export default () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.0595593 5.99998C0.0618752 4.83672 0.395075 3.75144 0.969915 2.83303L11.8178 14.2269C10.8103 15.3844 9.91189 16.6396 9.13871 17.9762C11.248 21.6565 14.3044 24.7251 17.9763 26.8491C19.2236 26.1341 20.4008 25.3104 21.4946 24.3908L32.1283 35.5596C31.4435 35.8297 30.6972 35.9774 29.9163 35.9758L5.99998 35.9282C2.68628 35.9216 0.00534803 33.23 0.0119452 29.9163L0.0595593 5.99998ZM26.8491 18.0115C25.9477 19.5697 24.8763 21.0171 23.6602 22.3283L34.5659 33.7829C35.4147 32.7502 35.9253 31.4288 35.9282 29.9878L35.9758 6.07149C35.9783 4.84217 35.6109 3.69848 34.9785 2.74571L23.8302 13.8497C24.9781 15.121 25.9918 16.5157 26.8491 18.0115ZM21.6851 11.7521L32.7455 0.735619C31.9203 0.305494 30.9826 0.0615341 29.9878 0.0595536L6.07149 0.0119395C5.00579 0.00981785 4.00443 0.285664 3.13603 0.771134L13.9182 12.096C15.1711 10.9734 16.5426 9.9806 18.0115 9.1387C19.3191 9.89504 20.5486 10.7712 21.6851 11.7521Z"
      fill="black"
    />
  </svg>
);
